import { useEffect, useMemo } from "react";
import { IItemProps } from "devextreme-react/form";

import { PageProps, UpdateDomTitleForForm } from "@ezhou/core";

import { groupRuleMappingColumns, dummyGroupRuleMappingRow } from "./model/metaData";
import { BaseMappings } from "./BaseMappings";

export const GroupRuleMappings = (pageProps: PageProps) => {
  useEffect(() => {
    UpdateDomTitleForForm(pageProps);
  });

  const logger = pageProps.loggerProvider.getLogger("GroupRuleMappings");
  logger.debug("Rendering GroupRuleMappings page");

  const editorItemOptions = useMemo(() => new Map<string, IItemProps>([
    [
      "perTransaction",
      {
        editorType: "dxCheckBox",
      },
    ],
    [
      "combineCreditDebitForSameAccount",
      {
        editorType: "dxCheckBox",
      },
    ],
  ]), []);

  return (
    <BaseMappings
      logger={logger}
      {...pageProps}
      baseUrl="group-rule-mappings"
      formTitle="Group Rule Mapping"
      dummyRow={dummyGroupRuleMappingRow}
      columnConfigs={groupRuleMappingColumns}
      additionalEditorItemOptions={editorItemOptions}
    />
  );
};
